const { REACT_APP_API_URL } = process.env;

const API_BASE_PATH = REACT_APP_API_URL || 'http://localhost:8080';

export default API_BASE_PATH;
